import styled from 'styled-components';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import {CartPreview} from './cart-preview/CartPreview';
import {useEffect, useMemo, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useCartContext} from '../context/CartContext';
import CloseIcon from '@mui/icons-material/Close';
import {useClickOutside} from '../../helpers/hooks/useClickOutside';

const ItemsCounter = styled.div`
  border-radius: .25rem;
  cursor: pointer;
  border: none;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;

  :after {
    content: attr(data-count);
    min-width: 1.2rem;
    min-height: 1.2rem;
    margin-left: .25rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    background: red;
    color: white;
  }
`;


const Content = styled.div`
  position: fixed;
  background-color: var(--bs-white);
  min-width: 50%;
  max-width: 100%;
  /* dvh donde exista (iOS 15.4+): 100vh en Safari movil incluye la franja de la barra
     de URL, y con muchos productos el final del panel (botón Tramitar) quedaba fuera
     de pantalla sin scroll posible. */
  max-height: calc(100vh - 100px);
  max-height: calc(100dvh - 100px);
  overflow: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  right: 0;
  box-shadow: 0 8px 16px 0 rgb(0 0 0 / 20%);
  z-index: 2;
  padding: 1rem;
  border-radius: 10px;

  /* En movil, panel a pantalla completa anclado arriba: la altura es exactamente el
     viewport visible, asi el scroll interno siempre llega al final. El padding
     inferior deja sitio para que la ultima fila no quede bajo la burbuja del chat. */
  @media (max-width: 768px) {
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: none;
    border-radius: 0;
    z-index: 1050;
    padding-bottom: 5rem;
  }
`;

const CloseBtnContainer = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  position: absolute;
  right: .5rem;
  top: 1rem;
  border: none;
  color: white;
  background-color: var(--bs-primary);
  opacity: 0.5;

  svg {
    width: 1rem;
  }
`;

/*
TODO
- create hook at the application layer for the cart (count, loading)
 */

export const CartPreviewButton = () => {
  const [modalCar, setModalCar] = useState(false);
  const location = useLocation();
  const { cart, loadCartBis } = useCartContext();

  const modalRef = useRef(null);
  useClickOutside(modalRef, () => setModalCar(false));

  const isCartRoute = useMemo(
    () => location.pathname === '/checkout',
    [location]
  );

  const itemCount = useMemo(() => {
    const productCount = cart?.products?.length ?? 0;
    const deprecatedProductCount = cart?.deprecatedProducts?.length ?? 0;
    return productCount + deprecatedProductCount;
  }, [cart]);

  useEffect(() => {
    if (!cart) {
      loadCartBis();
    }
  }, [cart, loadCartBis]);

  return (
    <div>
      {
        !isCartRoute && (
          <>
            <ItemsCounter
              data-count={itemCount}
              hideBadge={itemCount === 0}
              onClick={() => setModalCar(true)}>
              <ShoppingCartOutlinedIcon fontSize="large" className="text-primary" />
            </ItemsCounter>
            {
              modalCar && (
                <Content ref={modalRef}>
                  <CloseBtnContainer onClick={() => setModalCar(false)}>
                    <CloseIcon />
                  </CloseBtnContainer>
                  <CartPreview setModalCar={setModalCar} />
                </Content>
              )}
          </>
        )}
    </div>
  );
};